/** Validate time zones with the same IANA implementation used to render dates. */
export function isValidTimeZone(timeZone: string): boolean {
  try {
    new Intl.DateTimeFormat('en', { timeZone }).format(0);
    return timeZone.trim().length > 0;
  } catch {
    return false;
  }
}

/** Format supported display patterns. An omitted zone preserves calendar-picker dates. */
export function formatDatePattern(
  value: Date | string | number | null | undefined,
  pattern = 'MMM dd, yyyy',
  locale = 'en',
  timeZone?: string,
): string {
  if (value === null || value === undefined || value === '') {return '—';}
  const date = value instanceof Date ? value : new Date(value);
  if (!Number.isFinite(date.getTime())) {return '—';}
  try {
    const parts = new Intl.DateTimeFormat(locale, {
      timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
      calendar: 'gregory', numberingSystem: 'latn',
    }).formatToParts(date);
    const part = (type: Intl.DateTimeFormatPartTypes): string =>
      parts.find(value => value.type === type)?.value ?? '';
    const tokens: Record<string, string> = {
      yyyy: part('year'), yy: part('year').slice(-2), MM: part('month'), mm: part('month'),
      dd: part('day'), d: String(Number(part('day'))),
      MMM: new Intl.DateTimeFormat(locale, { timeZone, month: 'short' }).format(date),
    };
    return pattern.replace(/yyyy|MMM|yy|MM|mm|dd|d/g, token => tokens[token]);
  } catch {
    return '—';
  }
}
